import styled from "styled-components/macro";

export const Wrapper = styled.div`
  font-size: 0.75rem;
  padding: 1.5rem;

  *.highlighted {
    font-weight: normal;
    margin-top: 0;
    background-color: yellow;
  }
  *.highlighted2 {
    font-weight: normal;
    margin-top: 0;
    background-color: #87CEFA;
  }
  *.highlighted3 {
    font-weight: normal;
    margin-top: 0;
    background-color: #FBB239;
  }
  *.highlighted4 {
    font-weight: normal;
    margin-top: 0;
    background-color: #FFB776;
  }
`;

export const ModulesRow = styled.div`
  display: flex;
  gap: 2rem;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
    div {
    display: flex;
    column-gap: 1rem;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 0.5rem;
  width: 28rem;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: BounceIn 0.15s linear forwards;
  @keyframes BounceIn {
    0% { transform: scale(0); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
`;

export const ModalHeader = styled.div`
  font-weight: bold;
  color: white;
  background-color: #c0392b;
  padding: 0 1rem;
  border-radius: 0.5rem 0.5rem 0 0;
  height: 2.25rem;
  line-height: 2.25rem;
  font-size: 0.85rem;
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  p {
    text-align: center;
    font-size: 0.85rem;
    margin: 0;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.5rem;
`;
